import { useTheme } from '@mui/material/styles';
import { createTheme, Slider, SliderProps, ThemeProvider } from '@mui/material';
import { deepmerge } from '@mui/utils';
import styles from './SearchSlider.styles';

const SearchSlider: React.FC<SliderProps> = (props) => {
    const appTheme = useTheme();

    const theme = createTheme(
        deepmerge(appTheme, {
            direction: props.track === 'inverted' ? 'rtl' : 'isRTL',
        }),
    );

    //ToDO check and meybe replace with Slider "Inverted track" track="inverted"
    return (
        <ThemeProvider theme={theme}>
            <Slider
                {...props}
                sx={Object.assign(
                    {
                        '.MuiSlider-thumb': {
                            transform: props.track === 'inverted' ? 'translate(50%, -50%)' : '',
                        },
                    },
                    styles.root,
                )}
                track={'normal'}
            />
        </ThemeProvider>
    );
};

export default SearchSlider;
